<template>
    <div class="indexStyle">
        <div id="nav">
            <div class="logo">
                <img src="../assets/logo.png" alt="">
                <p class="navTitle">百博&图零官网后台管理系统</p>
            </div>
            
            <div @click="signOut" class="sign_out">退出</div>
        </div>
        <div class="content" >
            <SideLayout />
            <div class="contentDetails">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import SideLayout from '@/components/sideLayout.vue'

export default {
    components: {
      SideLayout
    },
    methods:{
        signOut(){
            window.sessionStorage.removeItem('sign')
            this.$router.push('/login')
        }
    }
}
</script>

<style lang="scss" scoped>
    .indexStyle {
        height: 100Vh;
        display: flex;
        flex-direction: column;
    }
    #nav {
        height: 50px;
        background: #333;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:0 100px;
        .logo {
            height: 100%;
            line-height: 50px;
            >img{
                margin-top: 5px;
                width: 40px;
                height: 40px;
            }
            .navTitle{
                float: right;
                font-size: 20px;
                font-weight: 500;
                color: #fff;
                margin:0 30px;
            }
        }
        
        .sign_out{
            float: right;
            color:#fff;
            cursor: pointer;

            &:hover{
                color:#999;
            }
        }
        
    }

    .content{
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        padding-right: 1%;
        flex: 1;

        .contentDetails{
            flex: 1;
            margin-left: 20px;
        }
    }
</style>